import { LitElement, html, css, unsafeCSS } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
// typical import
import gsap from 'gsap';

// get other plugins:
import ScrollTrigger from 'gsap/ScrollTrigger';
import Flip from 'gsap/Flip';
import Draggable from 'gsap/Draggable';
import SplitText from 'gsap/SplitText';

window.RDElement = LitElement;
window.RDhtml = html;
window.RDcss = css;
window.RDunsafeCSS = unsafeCSS;
window.RDunsafeHTML = unsafeHTML;

// register plugins
gsap.registerPlugin(ScrollTrigger, Flip, Draggable, SplitText);
window.gsap = gsap;
